<template>
    <div class="m-task">
        <h5 class="title"></h5>
        <div class="slogen"></div>
        <div class="page-detail">
            <div class="evt-time"><span class="label">活动时间：</span>2023年09月21日-2023年10月16日</div>
            <div class="rule-view" v-if="$global.deviceType == 'pc'">
                <div class="rule-item" v-for="(item,index) in rule_text" :key="index" :class="'r-' + (index+1)">
                {{ item.text }}
                </div>
            </div>
            <div class="rule-view" v-else>
                <div class="rule-item" v-for="(item,index) in rule_text_m" :key="index" :class="'r-' + (index+1)">
                {{ item.text }}
                </div>
            </div>            
        </div>
    </div>
</template>

<style lang="scss" scoped>
@mixin boxStyle ( $screenWidth ){

    .title{
        margin: 0 auto;

        @if ( $screenWidth == 1600) {
            width: 779px;
            height: 148px;
            background-image: url(~@/assets/images/pc/title-6.png);
        }@else if( $screenWidth == 1000 ) {
            width: 750px;
            height: 148px;
            background-image: url(~@/assets/images/m/title-6.png);
        }         
    }    

    @if ( $screenWidth == 1600) {

        .evt-time{
            width: 806px;
            height: 36px;
            line-height: 36px;
            margin: 36px auto 26px;
            text-align: center;
            background-image: url(~@/assets/images/pc/bg-evt-time.png);

            .label{
                font-size: 20px;
                color: #b43b33;
                font-family: 'HYJinKaiJ';
            }
        }

        .rule-view{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            width: 100%;

            .rule-item{
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                box-sizing: border-box;
                padding: 0 26px 0 140px;
                margin-bottom: 10px;

                &.r-1{
                    width: 580px;
                    height: 102px;
                    background-image: url(~@/assets/images/pc/bg-r-1.png);
                }

                &.r-2{
                    width: 580px;
                    height: 102px;
                    background-image: url(~@/assets/images/pc/bg-r-2.png);
                }
                
                &.r-3{
                    width: 580px;
                    height: 132px;
                    background-image: url(~@/assets/images/pc/bg-r-3.png);
                }
                
                &.r-4{
                    width: 580px;
                    height: 112px;
                    background-image: url(~@/assets/images/pc/bg-r-4.png);
                }
                
                &.r-5{
                    width: 580px;
                    height: 62px;
                    background-image: url(~@/assets/images/pc/bg-r-5.png);
                }
                
                &.r-6{
                    width: 580px;
                    height: 82px;
                    margin-top: -20px;
                    background-image: url(~@/assets/images/pc/bg-r-6.png);
                }                
            }
        }

    }@else if( $screenWidth == 1000 ) {
        .evt-time{
            width: 726px;
            height: 56px;
            line-height: 56px;
            margin: 36px auto 26px;
            text-align: center;
            background-image: url(~@/assets/images/m/bg-evt-time.png);

            .label{
                font-size: 24px;
                color: #b43b33;
                font-family: 'HYJinKaiJ';
            }
        }

        .rule-view{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            width: 100%;

            .rule-item{
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                box-sizing: border-box;
                padding: 0 26px 0 140px;
                margin: 0 auto 10px;

                &.r-1{
                    width: 710px;
                    height: 142px;
                    background-image: url(~@/assets/images/m/bg-r-1.png);
                }

                &.r-2{
                    width: 710px;
                    height: 222px;
                    background-image: url(~@/assets/images/m/bg-r-2.png);
                }
                
                &.r-3{
                    width: 710px;
                    height: 102px;
                    background-image: url(~@/assets/images/m/bg-r-3.png);
                }
                
                &.r-4{
                    width: 710px;
                    height: 142px;
                    background-image: url(~@/assets/images/m/bg-r-4.png);
                }
                
                &.r-5{
                    width: 710px;
                    height: 142px;
                    background-image: url(~@/assets/images/m/bg-r-5.png);
                }
                
                &.r-6{
                    width: 710px;
                    height: 102px;
                    background-image: url(~@/assets/images/m/bg-r-6.png);
                }                
            }
        }
    }    

}

@media screen and (min-width: 1000px){
@include boxStyle( 1600 );
}
@media screen and (min-width: 375px) and (max-width: 999px){
@include boxStyle( 1000 );
}
</style>

<script>
export default {
    data (){
        return {
            rule_text : [
                    {
                        tag : '',
                        text : '返利绑定梦三币将于活动结束后的7个工作日，统一发放至对应的游戏账号，请及时刷新可获得的返利金额，防止数据延迟。',
                    },
                    {
                        tag : '',
                        text : '每位玩家登录页面都可获得1份专属二维码与专属密钥，可通过邀请其他好友扫描二维码、填写密钥或点击分享链接进行绑定。',
                    },
                    {
                        tag : '',
                        text : '符合特殊条件的玩家被绑定时，会有金色小星标，你可以在“我的绑定返利”中查看，此类玩家在活动期间内消费的梦三币总额，其中5%将以绑定梦三币的形式发放至你的军师邮件中，每位玩家累计可获得返利无上限。',
                    },
                    {
                        tag : '',
                        text : '玩家可以同时邀请好友绑定自己，也可接受绑定，每位玩家可以主动邀请绑定的人数无上限，但只能接受1人的绑定邀请，绑定者之间不能双向绑定。',
                    },
                    {
                        tag : '',
                        text : '游戏礼包奖励将直接发放至对应游戏账号的军师邮件。',
                    }, 
                    {
                        tag : '',
                        text : '请勿使用任何非正当手段参与活动，一经发现将取消奖励资格。',
                    },                                                        
            ],
            rule_text_m : [
                    {
                        tag : '',
                        text : '返利绑定梦三币将于活动结束后的7个工作日，统一发放至对应的游戏账号，请及时刷新可获得的返利金额，防止数据延迟。',
                    },
                    {
                        tag : '',
                        text : '符合特殊条件的玩家被绑定时，会有金色小星标，你可以在“我的绑定返利”中查看，此类玩家在活动期间内消费的梦三币总额，其中5%将以绑定梦三币的形式发放至你的军师邮件中，每位玩家累计可获得返利无上限。',
                    },
                    {
                        tag : '',
                        text : '游戏礼包奖励将直接发放至对应游戏账号的军师邮件。',
                    },
                    {
                        tag : '',
                        text : '每位玩家登录页面都可获得1份专属二维码与专属密钥，可通过邀请其他好友扫描二维码、填写密钥或点击分享链接进行绑定。',
                    },
                    {
                        tag : '',
                        text : '玩家可以同时邀请好友绑定自己，也可接受绑定，每位玩家可以主动邀请绑定的人数无上限，但只能接受1人的绑定邀请，绑定者之间不能双向绑定。',
                    }, 
                    {
                        tag : '',
                        text : '请勿使用任何非正当手段参与活动，一经发现将取消奖励资格。',
                    },                                                        
            ],            
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/views/rule.vue